import TradePolicyPage from "../../components/TradePolicy/TradePolicyPage";

const TradePolicyContainer = () => {
  return <TradePolicyPage />;
};

export default TradePolicyContainer;
